// Misc
import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import compact from 'lodash/compact'
import classNames from 'classnames'

import { withStyles } from '@material-ui/core/styles'
// Selectors
import { connectGetters } from 'react-redux-getters'
import { getMe } from 'selectors/me'
import { getPermissions } from 'selectors/permissions'
import { getUnreadInboxItemsCount } from 'selectors/inbox'

// Icons
import { InboxIcon, BuildIcon, ShareIcon, ZapIcon, PlusCirleIcon, HelpCenterIcon } from 'atoms/Icons'
import AccountCircleIcon from '@material-ui/icons/AccountCircle'
import BusinessIcon from '@material-ui/icons/Business'
import SupervisorAccountIcon from '@material-ui/icons/SupervisorAccount'
import MonetizationOnIcon from '@material-ui/icons/MonetizationOn'
import PollIcon from '@material-ui/icons/Poll'

// Atoms
import Typography from '@material-ui/core/Typography'
import Hidden from '@material-ui/core/Hidden'
import Grow from '@material-ui/core/Grow'
import Desktop from 'components/Layout/UserLayout/Desktop'
import Mobile from 'components/Layout/UserLayout/Mobile'
import RequestsPolling from 'components/Requests/RequestsPolling'
import LiveChatsPolling from 'components/LiveChats/LiveChatsPolling'
import { UnlockFeatureDialog } from 'components/Billing/UnlockFeatureDialog'

// Styles
const styles = theme => ({
  counter: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    marginLeft: theme.spacing.unit,
    height: (theme.spacing.unit * 2),
    minWidth: (theme.spacing.unit * 2),
    padding: `0px ${theme.spacing.unit / 2}px`,
    fontSize: '11px',
    lineHeight: `${(theme.spacing.unit * 2) - 0}px`,
    borderRadius: theme.spacing.unit,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  counterWide: {
    borderRadius: theme.spacing.unit - 1,
  }
})

const mapGettersToProps = state => ({
  meGetter: getMe(state),
  permissionsGetter: getPermissions(state),
  unreadInboxItemsCountGetter: getUnreadInboxItemsCount(state),
})

export default
@connectGetters(mapGettersToProps)
@withStyles(styles)
class UserLayout extends Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    meGetter: PropTypes.object.isRequired,
    permissionsGetter: PropTypes.object.isRequired,
    unreadInboxItemsCountGetter: PropTypes.object.isRequired,
  }

  getInboxLabel() {
    const { unreadInboxItemsCountGetter, classes } = this.props
    const count = unreadInboxItemsCountGetter.isSucceded && unreadInboxItemsCountGetter.data
    const cx = classNames(classes.counter, { [classes.counterWide]: count > 9 })
    return (
      <Fragment>
        Inbox
        { !!count && (
          <Grow in>
            <Typography variant="caption" className={cx}>
              { Math.min(count, 999) }
            </Typography>
          </Grow>
        ) }
      </Fragment>
    )
  }

  getSidebarLinks() {
    const { permissionsGetter } = this.props
    const { buildTab, customizeTab, integrationsTab } = permissionsGetter.data
    return compact([
      { label: this.getInboxLabel(), to: '/inbox', icon: InboxIcon },
      buildTab && { label: 'Build', to: '/build', icon: BuildIcon },
      customizeTab && { label: 'Customize', to: '/customize', icon: PlusCirleIcon },
      integrationsTab && { label: 'Integrations', to: '/integrations', icon: ZapIcon },
      { label: 'Share', to: '/share', icon: ShareIcon },
    ])
  }

  getUserMenuLinks() {
    const { permissionsGetter, meGetter } = this.props
    const { billingTab, businessTab, managersTab } = permissionsGetter.data
    const profileRoute = meGetter.data.manager ? '/me/manager' : '/me'
    return compact([
      { label: 'User profile', to: profileRoute, icon: AccountCircleIcon },
      billingTab && { label: 'Billing', to: '/billing', icon: MonetizationOnIcon },
      businessTab && { label: 'Business', to: '/business', icon: BusinessIcon },
      managersTab && { label: 'Team', to: '/team', icon: SupervisorAccountIcon },
      { label: 'Stats', to: '/stats', icon: PollIcon },
      { label: 'Help center', external: true, to: 'https://indemandly.zendesk.com/', icon: HelpCenterIcon }
    ])
  }

  render() {
    const { unreadInboxItemsCountGetter, classes, ...rest } = this.props
    const sidebarLinks = this.getSidebarLinks()
    const userMenuLinks = this.getUserMenuLinks()
    return (
      <Fragment>
        <Hidden mdUp>
          <Mobile
            sidebarLinks={sidebarLinks}
            userMenuLinks={userMenuLinks}
            {...rest}
          />
        </Hidden>
        <Hidden smDown>
          <Desktop
            sidebarLinks={sidebarLinks}
            userMenuLinks={userMenuLinks}
            {...rest}
          />
        </Hidden>
        <RequestsPolling />
        <LiveChatsPolling />
        <UnlockFeatureDialog />
      </Fragment>
    )
  }
}
